import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { FiveBySevenShelfTalker } from './five-by-seven-shelf-talker';
import { ShelfTalkerCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/shelf-talker-card-content.component';
import { FireAndFlowerFiveBySevenBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/custom-cards-5x7/fire-and-flower-five-by-seven-background/fire-and-flower-five-by-seven-background.component';
import { FireAndFlower5By7ShelfTalkerContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/custom-cards-5x7/fire-and-flower-5-by-7-shelf-talker-content/fire-and-flower-5-by-7-shelf-talker-content.component';
import { GroupedByBrandShelfTalkerCardData } from '../../../../shelf-talkers/grouped-by-brand-shelf-talker-card-data';

export class FireAndFlower5By7ShelfTalkerCard extends FiveBySevenShelfTalker {
  getCardBackgroundComponent(data: GroupedByBrandShelfTalkerCardData): Type<CardBackgroundComponent> {
    return FireAndFlowerFiveBySevenBackgroundComponent;
  }

  getCardContentComponent(data: GroupedByBrandShelfTalkerCardData): Type<ShelfTalkerCardContentComponent> {
    return FireAndFlower5By7ShelfTalkerContentComponent;
  }

  public nonPerforatedBleedBorderInInches(): number {
    return 0;
  }
}
